"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createSfraFetch = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _crossFetch = _interopRequireDefault(require("cross-fetch"));
var _queryString = _interopRequireDefault(require("query-string"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const createSfraFetch = config => ( /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)(function* (endpoint, method, args, methodName) {
    const siteId = config.siteId;
    const locale = config.locale || 'default';
    const queryString = _queryString.default.stringify(args.query || {});
    const options = {
      method,
      headers: _objectSpread(_objectSpread({
        'Content-Type': 'application/json'
      }, config === null || config === void 0 ? void 0 : config.headers), args === null || args === void 0 ? void 0 : args.headers),
      body: args.body ? typeof args.body === 'object' ? JSON.stringify(args.body) : args.body : undefined
    };
    return new Promise((resolve, reject) => {
      (0, _crossFetch.default)(`${config.hostname}/on/demandware.store/Sites-${siteId}-Site/${locale.replace('-', '_')}/${endpoint}?${queryString}`, options).then( /*#__PURE__*/function () {
        var _ref2 = (0, _asyncToGenerator2.default)(function* (response) {
          let result;
          try {
            result = response.json && (yield response.json());
          } catch (e) {
            console.error(`Error parsing response as json for ${methodName}: `, e);
            try {
              result = response.text && (yield response.text());
            } catch (e) {
              console.error(`Error parsing response as for ${methodName}: `, e);
            }
          }
          !result || result.error || response.status >= 400 ? reject(result) : resolve(result);
        });
        return function (_x5) {
          return _ref2.apply(this, arguments);
        };
      }()).catch(error => reject(error));
    });
  });
  return function (_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}());
exports.createSfraFetch = createSfraFetch;